import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: [],
    deletedImages: []
  },
  mutations: {
    setCurrent (state, current) {
      state.current = current
    }
  },
  actions: {
    async getPayItems ({state, rootState, commit, rootGetters}, condition) {
      const payItems = rootState.project.current.type === rootState.enumData.projectType.normal.value
        ? await api.getPayItems(rootState.project.current._id, condition)
        : await api.getSheetDiffPayItems(rootState.project.current._id, condition)

      let maxLevel = 1
      payItems.forEach(p => {
        maxLevel = p.level > maxLevel ? p.level : maxLevel
      })

      for (let level = maxLevel; level > 1; level--) {
        const items = payItems.filter(p => p.level === level)
        if (items.length === 0) continue

        const iterator = items.values()

        let current = iterator.next().value
        let parent = payItems.find(p => p.origin === current.parent || p._id === current.parent)
        while (parent && current) {
          parent.sumAmount = parent.sumAmount !== undefined ? parent.sumAmount : 0
          parent.totalAmount = parent.totalAmount !== undefined ? parent.totalAmount : 0
          parent.sumAmount += current.sumAmount !== undefined ? current.sumAmount : (current.price * current.sumQuantity).toFixedNumber(2)
          parent.totalAmount +=
            current.totalAmount !== undefined ? current.totalAmount : (current.price * current.totalQuantity).toFixedNumber(2)

          current = iterator.next().value
          if (!current) break

          if (parent._id !== current.parent) parent = payItems.find(p => p.origin === current.parent || p._id === current.parent)
        }
      }

      const taxPayItem = payItems.find(p => p.isTaxItem)
      taxPayItem.sumAmount =
        (payItems.reduce(
          (previous, current) =>
            current.isTitle && current.isTaxItem !== true ? previous + current.sumAmount : previous,
          0
        ) *
        taxPayItem.taxPercent *
        0.01).toFixedNumber(2)
      taxPayItem.totalAmount =
        (payItems.reduce(
          (previous, current) =>
            current.isTitle && current.isTaxItem !== true ? previous + current.totalAmount : previous,
          0
        ) *
        taxPayItem.taxPercent *
        0.01).toFixedNumber(2)

      function getPayItemLatestHistory (payItem) {
        if (!payItem.history) return
        const result = {
          version: 0,
          changed: []
        }
        let approvedVersion = 0
        for (let index = payItem.history.length - 1; index >= 0; index--) {
          const history = payItem.history[index]
          const isUnApprovedVersion = !payItem.isApproved && history.version === payItem.version

          approvedVersion = isUnApprovedVersion ? approvedVersion : approvedVersion || history.version
          result.version = approvedVersion

          if (approvedVersion && approvedVersion === history.version) {
            result.changed.push(rootGetters['getEnumWord']('payItemUpdateType', history.type))
          }
        }

        result.changed = result.changed.join()

        return result
      }
      for (const payItem of payItems) {
        payItem.latestHistory = getPayItemLatestHistory(payItem)
      }

      commit('setCurrent', payItems)
      return payItems
    },
    async addProgressReport ({rootState}, data) {
      const result = await api.addProgressReport(rootState.project.current._id, data)
      require('downloadjs')(result, `進度報告_${new Date().toLocaleDateString().replace(/\//g, '-')}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    },
    async addImage ({state, rootState}, {invoiceId, imageData, extension}) {
      const { location } = await api.addInvoiceImageMeta(rootState.project.current._id, invoiceId, {extension})
      await api.addInvoiceImageContent(location, imageData)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/quantity.js